var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.29375 13.4999H3.5C3.36739 13.4999 3.24022 13.4473 3.14645 13.3535C3.05268 13.2597 3 13.1326 3 12.9999V10.2062C2.99978 10.1413 3.01236 10.0769 3.03702 10.0169C3.06169 9.95682 3.09796 9.90222 3.14375 9.8562L10.6438 2.3562C10.6903 2.30895 10.7457 2.27144 10.8069 2.24583C10.8681 2.22022 10.9337 2.20703 11 2.20703C11.0663 2.20703 11.132 2.22022 11.1931 2.24583C11.2543 2.27144 11.3097 2.30895 11.3563 2.3562L14.1438 5.1437C14.191 5.19022 14.2285 5.24568 14.2541 5.30684C14.2797 5.368 14.2929 5.43364 14.2929 5.49995C14.2929 5.56625 14.2797 5.63189 14.2541 5.69305C14.2285 5.75421 14.191 5.80967 14.1438 5.8562L6.64375 13.3562C6.59773 13.402 6.54313 13.4383 6.48307 13.4629C6.42301 13.4876 6.35868 13.5002 6.29375 13.4999Z",
    stroke: "#EF2C5A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 4L12.5 7.5",
    stroke: "#EF2C5A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.904bb1cf41fc929bbcbd1131e59f2a63.svg";
export { ForwardRef as ReactComponent };